import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class SuchparameterService {

  constructor(private route: ActivatedRoute,
              private router: Router) {
  }

  /**
   * LastRequest von StateServices (d.h. die Parameter von Suchmasken)
   * wird z.B. bei der Navigation via Menu zurueckgesetzt
   * (aber nicht, wenn via Back-Button oder Breadcrumbs navigiert wird)
   *
   * Bei der Navigation via Menu wird der queryParam reset=true gesetzt.
   */
  shouldResetLastRequest(): boolean {
    const shouldReset = this.route.snapshot.queryParams['reset'] === 'true';
    if (shouldReset) {
      this.removeQueryParameter();
    }
    return shouldReset;
  }

  private removeQueryParameter() {
    this.router.navigate(
      [],
      {
        replaceUrl: true
      }
    );
  }
}
